export const GloriousCrew = {
    NAME: "Glorious Crew",
    EMAIL: "milan@gloriouscrew.com",
    TEL: "02 36755850",
    WWW: "www.gloriouscrew.com/",
    FB: "www.facebook.com/gcrewestate",
    IG: "www.instagram.com/glorious.crew/",
    LINKEDIN: "www.linkedin.com/company/gloriouscrew/"
}